export default function ExpertiseSection() {
  const brands = [
    { name: 'Winkhaus', icon: 'ri-lock-line' },
    { name: 'Roto', icon: 'ri-settings-3-line' },
    { name: 'GU', icon: 'ri-tools-line' },
    { name: 'MACO', icon: 'ri-hammer-line' },
    { name: 'Siegenia', icon: 'ri-shield-line' },
    { name: 'Hoppe', icon: 'ri-door-lock-line' }
  ];

  const expertisePoints = [
    {
      icon: 'ri-tools-fill',
      title: 'Diagnostic Précis',
      description: 'Identification rapide des pannes grâce à notre expertise technique approfondie'
    },
    {
      icon: 'ri-box-3-fill',
      title: 'Stock Permanent',
      description: 'Pièces d\'origine disponibles immédiatement pour toutes les marques'
    },
    {
      icon: 'ri-time-fill',
      title: 'Intervention Rapide',
      description: 'Réparation effectuée dès le premier passage dans 90% des cas'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Garantie 2 Ans',
      description: 'Toutes nos interventions sont garanties pour votre tranquillité'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-award-fill mr-2"></i>
            Notre Expertise
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Spécialistes de la Quincaillerie Toutes Marques
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Une maîtrise technique complète des systèmes de fermeture et mécanismes de châssis
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/850b12a1257ffb7e1fc7a4c425a0ff00.jpg"
                alt="Expertise technique en réparation"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-teal-500 text-white rounded-2xl p-6 shadow-2xl">
              <div className="text-4xl font-bold mb-1">15+</div>
              <div className="text-sm opacity-90">Années d'Expérience</div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Une Expertise Reconnue sur Toutes les Marques
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Nos techniciens sont formés et certifiés sur l'ensemble des systèmes de quincaillerie du marché. 
              Nous maîtrisons les spécificités de chaque marque et disposons d'un stock permanent de pièces d'origine.
            </p>

            {/* Expertise Points */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              {expertisePoints.map((point, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className={`${point.icon} text-xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{point.title}</h4>
                    <p className="text-sm text-gray-600">{point.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Brands */}
            <div className="bg-gray-50 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-4">Marques Maîtrisées</h4>
              <div className="grid grid-cols-3 gap-4">
                {brands.map((brand, index) => (
                  <div key={index} className="flex items-center gap-2 text-gray-700">
                    <div className="w-8 h-8 flex items-center justify-center bg-white rounded-lg">
                      <i className={`${brand.icon} text-teal-600`}></i>
                    </div>
                    <span className="text-sm font-medium">{brand.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Un Problème de Châssis ? Nous Avons la Solution
          </h3>
          <p className="text-lg mb-8 opacity-90 max-w-2xl mx-auto">
            Diagnostic gratuit par WhatsApp ou visite sur place sous 48h
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/32475585219"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-whatsapp-line text-xl mr-2"></i>
              Prendre RDV pour un diagnostic
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-800 transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl mr-2"></i>
              Prendre Rendez-vous
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
